import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EndPageRoutingModule } from './end-page-routing.module';
import { SetClientStatusComponent } from './set-client-status/set-client-status.component';
import { EndingInputDataModule } from './ending-input-data.module';

@NgModule({
  imports: [
    CommonModule,
    EndPageRoutingModule,
    // EndingInputDataModule
  ],
  declarations: [SetClientStatusComponent]
})
export class EndPageModule { }
